module.exports = __webpack_public_path__ + "img/progress-3.1d63ca26.png";